import { createSlice as e } from "@reduxjs/toolkit";
const t = {
  filterOptions: {}
}, r = e({
  name: "filter",
  initialState: t,
  reducers: {}
}), c = r.reducer;
export {
  c as default
};
